
const state = {
  assigned_provider_ids: [],
  id: null,
  options: {},
  short_name: '',
  title: '',
}

export const requiredFields = [
  { key: 'short_name' },
  { key: 'title' },
]

export default state
